import {Component, inject, OnInit,Input} from '@angular/core';
import {IndexIoService} from '../../../services/index-io.service';
import {NgForOf, NgIf} from '@angular/common';
import {TableModule} from 'primeng/table';
import {IndexPdfExcelPalleteComponent} from '../index-pdf-excel-pallete/index-pdf-excel-pallete.component';
import {ProgressSpinner} from "primeng/progressspinner";

@Component({
  selector: 'bnpp-indx-index-keyinfo',
    imports: [
        NgIf,
        NgForOf,
        TableModule,
        IndexPdfExcelPalleteComponent,
        ProgressSpinner
    ],
  templateUrl: './index-keyinfo.component.html',
  styleUrl: './index-keyinfo.component.scss',
  standalone: true,
})
export class IndexKeyinfoComponent implements OnInit {
  private indexInfoService = inject(IndexIoService);
  @Input() mdsCode:string= '';
  currentDate:string = '';

  indexKeyInfo = this.indexInfoService.indexKeyInfo;
  indexCompositionInfo = this.indexInfoService.indexCompositionInfo;
  ngOnInit(): void {
    this.currentDate = this.getDateNYearsAgo();
    this.indexInfoService.getIndexKeyInfo(this.mdsCode);
    this.indexInfoService.getCompositionInfo(this.mdsCode);
  }

  getDateNYearsAgo(): string {
    const currentDate = new Date();
    return currentDate.toISOString().split('T')[0]; // Format as YYYY-MM-DD
  }
}
